// extracted by mini-css-extract-plugin
module.exports = {"spec":"PartnerListItem_spec__Zqpeo","link":"PartnerListItem_link__DJJpY"};